import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/auth";
import { PageHeader } from "@/pages/Classes";
import { Gift, ArrowRight } from "lucide-react";

export default function Refer() {
  const { code } = useParams();
  const nav = useNavigate();
  const [state, setState] = useState({ loading: true, ok: false, first_name: "", code: "" });

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get(`/refer/${code}`);
        localStorage.setItem("ref_code", r.data.code);
        setState({ loading: false, ok: true, first_name: r.data.first_name, code: r.data.code });
      } catch {
        setState({ loading: false, ok: false });
      }
    })();
  }, [code]);

  if (state.loading) return <div className="pt-40 text-center text-zinc-500">Loading…</div>;
  if (!state.ok) return (
    <div className="pt-40 text-center px-6">
      <h2 className="font-display text-3xl uppercase mb-3">Referral not found.</h2>
      <p className="text-zinc-500 mb-6">Double-check the link, or head to classes to enrol as a new student.</p>
      <div className="flex gap-3 justify-center">
        <Link to="/classes" className="btn-red">Browse classes</Link>
        <Link to="/" className="btn-ghost" data-testid="page-back-link">Back to home</Link>
      </div>
    </div>
  );

  return (
    <>
      <PageHeader eyebrow="Referral" title={`Welcome from ${state.first_name || "a friend"}.`} back />
      <div className="max-w-[900px] mx-auto px-4 sm:px-6 py-12" data-testid="refer-landing">
        <div className="card-surface p-10 text-center border-l-4 border-emerald-500">
          <Gift size={40} className="mx-auto text-emerald-400 mb-4"/>
          <div className="eyebrow mb-2 text-emerald-400">Your first class is on us</div>
          <h2 className="font-display text-3xl uppercase mb-4">Bring a friend, both get a free class.</h2>
          <p className="text-zinc-300 max-w-lg mx-auto mb-6">
            {state.first_name ? `${state.first_name}` : "A dancer here"} referred you. Book any term and your first class is credited free — and they get one too. 
            Your referral code <strong className="font-mono text-white">{state.code}</strong> is already saved and will be applied automatically at checkout.
          </p>
          <Link to="/classes" className="btn-red inline-flex" data-testid="refer-continue">
            Pick a class <ArrowRight size={14}/>
          </Link>
        </div>
      </div>
    </>
  );
}
